<template>
  <!-- Dashboard Content
	================================================== -->
  <div class="dashboard-content-container" data-simplebar>
    <div class="dashboard-content-inner">
      <!-- Dashboard Headline -->
      <div class="dashboard-headline ">
        <h3>Messages</h3>

        <!-- Breadcrumbs -->
        <nav id="breadcrumbs" class="dark">
          <ul>
            <li><a href="#">Home</a></li>
            <li><a href="#">Dashboard</a></li>
            <li>Messages</li>
          </ul>
        </nav>
      </div>

      <!-- Row -->
      <div class="row m-0">
        <!-- Dashboard Box -->
        <div class="col-xl-12">
          <div class="dashboard-box margin-top-0">
            <!-- Headline -->
            <div class="headline">
              <h3><i class="icon-material-outline-email"></i> {{ totalMessages }} Messages</h3>
            </div>

            <div class="content">
              <ul class="dashboard-box-list">
                <li v-for="(notification, index) in notifications" :key="index">
                  <!-- Overview -->
                  <div class="freelancer-overview manage-candidates">
                    <div class="freelancer-overview-inner">
                      <!-- Avatar -->
                      <div class="freelancer-avatar">
                        <span
                          class="notification-icon "
                          :class="[notification.read_at === null ? 'notification__background__active' : '']"
                          ><i
                            :class="[
                              notification.read_at === null
                                ? 'notification__text__active icon-material-outline-email'
                                : 'icon-material-outline-drafts',
                            ]"
                          ></i
                        ></span>
                      </div>

                      <!-- Name -->
                      <div class="freelancer-name">
                        <h4 :class="[notification.read_at === null ? '' : 'text-muted']"
                          >{{ notification.data.from }} -
                          {{ notification.data.subject }}
                        </h4>

                        <!-- Details -->
                        <span class="freelancer-detail-item">
                          <i class="icon-feather-clock"></i>
                          {{ formatDate(notification.created_at) }}</span
                        >

                        <!-- Body -->
                        <p>{{ notification.data.body }}</p>

                        <!-- Buttons -->
                        <div class="buttons-to-right always-visible margin-bottom-5">
                          <a
                            href="#"
                            class="button ripple-effect button-sliding-icon"
                            :title="[notification.read_at === null ? 'Mark as read' : 'Read']"
                            :class="[notification.read_at === null ? 'dark' : 'gray isDisabled']"
                            @click="markAsRead(notification.id, index)"
                          >
                            {{ notification.read_at === null ? 'Mark as read' : 'Read' }}
                            <i class="icon-material-outline-check-circle"></i
                          ></a>

                          <a
                            href="#"
                            class="button gray ripple-effect ico text-danger background-red"
                            title="Delete message"
                            data-tippy-placement="top"
                            @click="deleteNotification(notification.id, index)"
                            ><i class="icon-feather-trash-2"></i
                          ></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <!-- Pagination -->
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-md-12 d-flex justify-content-center">
                <!-- Projects -->
                <div class="pagination-container margin-top-30 margin-bottom-60">
                  <nav class="pagination">
                    <ul>
                      <li class="pagination-arrow" :class="[prevPageUrl === null ? 'isDisabled' : '']"
                        ><a href="#" class="ripple-effect" @click="getPrevPage()"
                          ><i class="icon-material-outline-keyboard-arrow-left"></i></a
                      ></li>
                      <li v-for="index in paginationTotal" :key="index">
                        <a
                          href="#"
                          @click="getNotifications(index)"
                          class="ripple-effect"
                          :class="[currentPage === index ? 'current-page' : '']"
                          >{{ index }}</a
                        >
                      </li>
                      <li class="pagination-arrow " :class="[nextPageUrl === null ? 'isDisabled' : '']"
                        ><a href="#" class="ripple-effect" @click="getNextPage()"
                          ><i class="icon-material-outline-keyboard-arrow-right"></i></a
                      ></li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
            <!-- Pagination / End -->
          </div>
        </div>
      </div>

      <app-footer></app-footer>
    </div>
  </div>
  <!-- Dashboard Content / End -->
</template>

<script>
  /* eslint-disable no-console */
  import { getCall, postCall } from '../../../core/services/http.service';
  import { AppFooter } from '../../partials/user-dashboard';
  import {
    ALL_MY_NOTIFICATIONS,
    DELETE_NOTIFICATION,
    MARK_NOTIFICATION_AS_READ,
    UNREAD_NOTIFICATIONS,
  } from '../../../core/config/endpoints/notifications';
  import { subString, formatDate } from '../../../plugins/handlers';
  import { DOMAIN_NAME } from '../../../plugins/config/constants';
  import Snackbar from 'node-snackbar';

  export default {
    name: 'Messages',
    components: {
      AppFooter,
    },
    data() {
      return {
        projectName: DOMAIN_NAME,
        notifications: [],
        notificationMessage: 'Fetching notification',
        currentPage: 1,
        firstPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        paginationTotal: 0,
        itemsPerPage: 0,
        totalMessages: 0,
      };
    },

    methods: {
      getNotifications(pageNumber = 1) {
        pageNumber = pageNumber ? pageNumber : this.currentPage;
        this.$store.commit('setIsLoaded', true);
        getCall(ALL_MY_NOTIFICATIONS.PAGE(pageNumber))
          .then((response) => {
            this.firstPageUrl = response.data.data.first_page_url;
            this.nextPageUrl = response.data.data.next_page_url;
            this.prevPageUrl = response.data.data.prev_page_url;
            this.prevPageUrl = response.data.data.prev_page_url;
            this.totalMessages = response.data.data.total;
            this.itemsPerPage = response.data.data.per_page;
            this.currentPage = response.data.data.current_page;
            this.getPaginationTotal();
            return (this.notifications = response.data.data.data);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.$store.commit('setIsLoaded', false);
          });
      },

      getUnreadNotifications(pageNumber = 1) {
        pageNumber = pageNumber ? pageNumber : this.currentPage;
        this.$store.commit('setIsLoaded', true);
        getCall(UNREAD_NOTIFICATIONS.PAGE(pageNumber))
          .then((response) => {
            this.firstPageUrl = response.data.data.first_page_url;
            this.nextPageUrl = response.data.data.next_page_url;
            this.prevPageUrl = response.data.data.prev_page_url;
            this.prevPageUrl = response.data.data.prev_page_url;
            this.totalMessages = response.data.data.total;
            this.itemsPerPage = response.data.data.per_page;
            this.currentPage = response.data.data.current_page;
            this.getPaginationTotal();
            return (this.notifications = response.data.data.data);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.$store.commit('setIsLoaded', false);
          });
      },

      subString(string, length) {
        return subString(string, length);
      },

      formatDate(dateTime) {
        return formatDate(dateTime);
      },

      markAsRead(notificationId, index) {
        let notificationsId = {
          notification_ids: [notificationId],
        };
        postCall(MARK_NOTIFICATION_AS_READ, notificationsId)
          .then(() => {
            this.notifications[index].read_at = new Date().getTime();
          })
          .catch((error) => {
            console.log(error);
          });
      },

      deleteNotification(notificationId, index) {
        let notificationsId = {
          notification_ids: [notificationId],
        };
        postCall(DELETE_NOTIFICATION, notificationsId)
          .then(() => {
            this.notifications.splice(index, 1);
            Snackbar.show({
              text: 'Deleted!',
              pos: 'bottom-center',
              showAction: false,
              actionText: 'Dismiss',
              duration: 2000,
              textColor: '#fff',
              backgroundColor: '#383838',
            });
          })
          .catch((error) => {
            console.log(error);
          });
      },

      getPrevPage() {
        this.currentPage--;
        this.getNotifications();
      },
      getNextPage() {
        this.currentPage++;
        this.getNotifications();
      },
      getPaginationTotal() {
        this.paginationTotal = Math.ceil(this.totalMessages / this.itemsPerPage);
      },
    },

    mounted() {
      return this.getNotifications();
    },
  };
</script>

<style>
  .pagination ul li + li {
    margin-left: 5px !important;
  }
  .notification__background__active {
    background-color: var(--main-black) !important;
  }
  .notification__text__active {
    color: #fff;
  }
  .background-red {
    background-color: var(--main-red) !important;
  }
  .background-red i {
    color: var(--main-light) !important;
  }
  .isDisabled {
    color: currentColor !important ;
    cursor: not-allowed !important ;
    opacity: 0.5 !important ;
    text-decoration: none !important ;
    pointer-events: none !important ;
  }

  .isDisabled > li {
    color: currentColor;
    display: inline-block; /* For IE11/ MS Edge bug */
    pointer-events: not-allowed;
    text-decoration: none;
  }
</style>
